import { useState } from 'react';

import { Modal, ModalCloseButton, ModalHeader, ModalBody } from '@grupoboticario/flora-react';
import { ResellerAvailableCatalogs } from 'core/services/bff';

import { ShareGuideCycleStyle } from './ShareGuideCycle.styles';
import ShareGuideCycleFooter from './ShareGuideCycleFooter';
import ShareYourGuide from './ShareYourGuide';
import SocialNetworks from './SocialNetworks';

enum STEP {
  VIEW_SHARE = 'view-share',
  SOCIAL_NETWORK = 'social-network',
}

type ShareModal = {
  open: boolean;
  clickCloseShareModal: () => void;
  selectedGuide: ResellerAvailableCatalogs;
};

const ShareGuideCycle = ({ open, clickCloseShareModal, selectedGuide }: ShareModal) => {
  const [step, setStep] = useState(STEP.VIEW_SHARE);

  const shareClick = () => {
    setStep(STEP.SOCIAL_NETWORK);
  };

  const clickCloseButton = () => {
    setStep(STEP.VIEW_SHARE);
    clickCloseShareModal();
  };

  return (
    <Modal open={open}>
      <ShareGuideCycleStyle.ModalShareGuide size="large" data-testid="share-guide-cycle-modal">
        <ModalCloseButton onClick={clickCloseButton} />
        <ModalHeader>
          <ShareGuideCycleStyle.ModalTitle level={6}>
            {step === STEP.VIEW_SHARE
              ? 'Compartilhe seu catálago'
              : 'Escolha como compartilhar sua loja'}
          </ShareGuideCycleStyle.ModalTitle>
        </ModalHeader>
        <ModalBody>
          {step === STEP.VIEW_SHARE ? (
            <ShareYourGuide link={selectedGuide?.link} banner={selectedGuide?.banner || ''} />
          ) : (
            <SocialNetworks link={selectedGuide?.link} selectedGuide={selectedGuide} />
          )}
        </ModalBody>
        {step === STEP.VIEW_SHARE && (
          <ShareGuideCycleFooter selectedGuide={selectedGuide} shareClick={shareClick} />
        )}
      </ShareGuideCycleStyle.ModalShareGuide>
    </Modal>
  );
};

export default ShareGuideCycle;
